import withProps from 'recompose/withProps';
import MaskedInput from 'react-maskedinput';
import PlainInput from './PlainInput';


export default withProps({
  component: MaskedInput,
  mask: '11111111111111111111',
})(PlainInput);
